import { api } from "@/lib/api";
import { createAppointmentReschedule } from "@/lib/appointment-reschedule";
import type { uuid } from "@/interfaces";
import { toAppointmentJoin } from "@/repositories/appointment-records";
import { activeOrganization, type AppointmentJoin } from "@/repositories/appointments.repository";

const reschedule = createAppointmentReschedule(api.appointments);

export async function rescheduleAppointment(id: uuid, date: string): Promise<AppointmentJoin> {
  return toAppointmentJoin(await reschedule(id, { date, actingOrganization: activeOrganization() }));
}
